/**
 * api接口统一管理
 */
import {get, post, put} from './axios';

/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */

// 获取当前登录用户
export const getCurrentUser = params => get(`/user/current`, params)

// 查询用户未读消息数量
export const getNoReadCount = params => get(`/user-message/noReadCount`, params)

// 分页查询资讯评论
export const getCommentList = params => get(`/information-comment-app/page/${params.number}/${params.limit}`, params)

// 分页查询学习进度
export const getLearningProgress = params => get(`/learning-progress-app/page/${params.number}/${params.limit}`, params)

// 用户学习进度
export const getUserLearningProgress = params => get(`/learning-progress-app/userLearningProgress`, params)

// 分页查询新闻资讯、质控课程、质控公告浏览历史
export const getUserHistory = params => get(`/history/page/${params.number}/${params.limit}`, params)

// 分页查询我的收藏
export const getUserCollect = params => get(`/information-collect-app/page/${params.number}/${params.limit}`, params)

// 分页查询我的评论
export const getUserComment = params => get(`/information-comment-app/userComment/${params.number}/${params.limit}`, params)

// 修改医生认证状态
export const changeDoctorInfo = params => put(`/doctor-info/appUpdate/${params.dv}`, params.data)

// 分页查询用户消息表
export const getMessageList = params => get(`/user-message/pageVO/${params.number}/${params.limit}`, params)

// 按 id 查询用户消息
export const getMessageDetails = params => get(`/user-message/${params.id}`, params)

// 上传到医生目录，单个上传：医生图片
export const uploadDoctor = params => post(`/upload/doctor`, params)

// 用户签到
export const signUserApp = params => get(`/sign-user-app/signToday`, params)

// 分页查询我的点赞
export const getPraiseList = params => get(`/information-like-app/page/${params.number}/${params.limit}`, params)

// 修改手机号：发送手机验证码
export const getChangePhoneCode = params => post(`/open/auth/sms-update-user/${params.phone}`, params)

// 账号手机号验证
export const verifyPhoneCode = params => post(`/user/sms-old-phone/${params.phone}/${params.code}`, params)

// 修改新手机号
export const changeNewPhone = params => post(`/user/sms-new-phone/${params.phone}/${params.code}`, params)

//修改密码
export const changePasswordApi = params => post(`/user/change-password-new`, params)

// 账号销毁：发送手机验证码
export const getDestroyPhoneCode = params => post(`/open/auth/sms-clear-user/${params.phone}`, params)

// 应用静态资源
export const getStaticResource = params => get(`/open/app/static`, params)

// 账号销毁
export const setPhoneDestroy = params => post(`/open/auth/sms-clear-user/${params.phone}/${params.code}`, params)



// WEBPACK FOOTER //
// ./src/api/user.js